import { BASE_API_URL } from "../../../Components/config";

const API = `${BASE_API_URL}/api/v1/session-rooms`;

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
});

const call = async (url, options = {}) => {
  const res = await fetch(url, { ...options, headers: headers() });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error((data && typeof data.detail === "string" && data.detail) || "Something went wrong. Try again.");
    err.status = res.status;
    throw err;
  }
  return data;
};

/** A session's live activities: the bank, launching, answering, marking. */
export const activityApi = {
  bank: (sessionGuid, { q, topic } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (topic) params.set("topic", topic);
    return call(`${API}/${sessionGuid}/activities/bank?${params}`);
  },
  current: (sessionGuid) => call(`${API}/${sessionGuid}/activities/current`),
  launch: (sessionGuid, body) =>
    call(`${API}/${sessionGuid}/activities`, { method: "POST", body: JSON.stringify(body) }),
  advance: (sessionGuid, id) => call(`${API}/${sessionGuid}/activities/${id}/advance`, { method: "POST" }),
  end: (sessionGuid, id) => call(`${API}/${sessionGuid}/activities/${id}/end`, { method: "POST" }),
  clear: (sessionGuid, id) => call(`${API}/${sessionGuid}/activities/${id}`, { method: "DELETE" }),
  answer: (sessionGuid, id, questionGuid, text) =>
    call(`${API}/${sessionGuid}/activities/${id}/responses`, {
      method: "POST",
      body: JSON.stringify({ question_guid: questionGuid, answer_text: text }),
    }),
  review: (sessionGuid, id, responseGuid, body) =>
    call(`${API}/${sessionGuid}/activities/${id}/responses/${responseGuid}`, {
      method: "PUT",
      body: JSON.stringify(body),
    }),
  release: (sessionGuid, id, responseGuids) =>
    call(`${API}/${sessionGuid}/activities/${id}/release`, {
      method: "POST",
      body: JSON.stringify({ response_guids: responseGuids || null }),
    }),
  insight: (sessionGuid, id, questionGuid) =>
    call(`${API}/${sessionGuid}/activities/${id}/insight`, {
      method: "POST",
      body: JSON.stringify({ question_guid: questionGuid }),
    }),
  unlock: (sessionGuid, id, code) =>
    call(`${API}/${sessionGuid}/activities/${id}/unlock`, { method: "POST", body: JSON.stringify({ code }) }),
};
